import React from "react";
import "./Header.css";
import {Link, useNavigate} from "react-router-dom";
import {Button} from "primereact/button";
import ProfileMenu from "./ProfileMenu";

const userEmptyIcon = "/icons/user-empty2.png";

const InstructorHeader = (props) => {
    const {isAuthenticated, setIsAuthenticated, logout} = props;
    const navigate = useNavigate();

    return (
        <div className="header">
            <Link to='/' className="left part">
                <img src="/assets/images/culogo_orjinal.svg" alt="logo" style={{height: "32px"}}></img>
            </Link>
            <div className="right part flex flex-group gap-3">
                <Button label="Öğrenci" text onClick={() => navigate("/")} size="small"
                        tooltip="Buradan öğrenci görünümüne geçiş yapın." tooltipOptions={{position: 'bottom', hideDelay: 250 }}/>
                <Button label="Kurslarım" text onClick={() => navigate("/instructor/courses")} size="small"/>
                {/*<Button icon="pi pi-bell" rounded outlined/>*/}
                <ProfileMenu logout={logout}/>
            </div>

        </div>
    );
}
export default InstructorHeader;
